export default __webpack_public_path__ + "static/media/signal_9.d1d48dba.mp3";